<template>
	<div id="systemSettings">
		个人中心
	</div>
</template>
<script>
	import {
		mapMutations
	} from 'vuex'
	export default {
		data() {
			return {
				
			};
		},
		mounted() {
			// this.$util.post(
			// 	"/login/login", {
			// 		username: this.ruleForm.username,
			// 		password: this.$md5(this.ruleForm.pass),
			// 	},
			// 	(res) => {
			// 		
			// 		if (res.code == 1) {
			// 			localStorage.setItem("token", res.data.token);
			// 			this.$router.push({
			// 				path: "/main",
			// 				// query: {
			// 				//   id: 1,
			// 				// },
			// 			});
			// 		}
			// 	}
			// );
		},
		methods: {
			...mapMutations(['setIslogin']),
			
		},
		components: {},
	};
</script>
<style lang="less" scoped>

</style>